<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="date_select_block flex">
          <DateSelect ref="dateFrom"/>
          <DateSelect ref="dateTo"/>
          <div class="flex">
            <button @click="updateRange()" class="btn btn-outline-info btn-sm">-1 год</button>
            <button @click="updateRange(true)" class="btn btn-outline-info btn-sm">+1 год</button>
          </div>
          <div class="flex">
            <button @click="addRange" class="btn btn-outline-success btn-sm">Добавить период</button>
          </div>
        </div>
      </div>
    </div>
    <template v-if="ranges.length">
      <div class="flex flex-wrap">
        <div class="card range_block" v-for="(r, i) in ranges" :key="i">
          <div class="card-body">
            <button @click="removeRange(i)" class="btn btn-outline-danger btn-xs remove_btn"><i
              class="icon-fa icon-fa-remove"/></button>
            <ConversionData :data="r" :updateData="() => updateChartData()"/>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <Chat :chartData="ranges"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import DateSelect from "@/views/reports/components/DateSelect.vue";
import moment from 'moment'
import ConversionData from "@/views/reports/components/conversions/ConversionData.vue";
import Chat from "@/views/reports/components/conversions/Chart.vue";

export default {
  components: {
    Chat,
    ConversionData,
    DateSelect,
  },
  data() {
    return {
      range: {},
      ranges: [],
    }
  },
  methods: {
    updateChartData() {
      this.ranges = [...this.ranges];
    },
    removeRange(index) {
      const ranges = [...this.ranges];
      delete ranges[index];
      this.ranges = ranges.filter((r) => r);
    },
    updateRange(plus = false) {
      const dateFrom = moment(this.$refs.dateFrom.date, "DD.MM.YYYY");
      const dateTo = moment(this.$refs.dateTo.date, "DD.MM.YYYY");
      if (plus) {
        dateFrom.add(1, 'year');
        dateTo.add(1, 'year');
      } else {
        dateFrom.subtract(1, 'year');
        dateTo.subtract(1, 'year');
      }
      this.$refs.dateFrom.date = dateFrom.format("DD.MM.YYYY");
      this.$refs.dateTo.date = dateTo.format("DD.MM.YYYY");
    },
    addRange() {
      const range = {
        start: this.$refs.dateFrom.date,
        end: this.$refs.dateTo.date
      }
      console.log(range);
      let pass = true;
      Object.values(range).forEach((r) => {
        if (!r || moment(r, "DD.MM.YYYY").format("DD.MM.YYYY") !== r) {
          toastr['warning']('Дата периода не валидна');
          pass = false;
        }
      })
      if (!pass) return;
      let ranges = [...this.ranges];
      ranges.push(range);
      ranges = ranges.sort((a, b) => {
        return moment(a.start, "DD.MM.YYYY").unix() - moment(b.start, "DD.MM.YYYY").unix();
      })
      setTimeout(() => {
        this.ranges = ranges;
      }, 200)
    }
  }
}

</script>

<style scoped>
.date_select_block .flex {
  margin-right: 5px;
}

.range_block {
  position: relative;
}

.range_block .remove_btn {
  position: absolute;
  right: 5px;
  top: 5px;
}

.range_block .card-body {
  padding-right: 45px;
}

</style>
